import { render, staticRenderFns } from "./UpdateAltCoinOfflinePoolModal.vue?vue&type=template&id=8ccabca8&scoped=true&"
import script from "./UpdateAltCoinOfflinePoolModal.vue?vue&type=script&lang=js&"
export * from "./UpdateAltCoinOfflinePoolModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccabca8",
  null
  
)

export default component.exports